<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps({
  label: {
    type: String,
    default: "?",
  },

  estimate: {
    type: Boolean,
    default: false,
  },
});

const formattedLabel = computed(() => {
  const upperLabel = String(props.label).toUpperCase();

  if (["A+++++", "A++++", "A+++", "A++", "A+", "A", "B", "C", "D", "E", "F", "G"].includes(upperLabel)) {
    return upperLabel;
  }

  return "?";
});

const colorClass = computed(() => {
  if (props.estimate === true) {
    return "color-unknown";
  }

  switch (String(props.label).toLowerCase()) {
    case "a+++++":
      return "color-a-plus-plus-plus-plus-plus";
    case "a++++":
      return "color-a-plus-plus-plus-plus";
    case "a+++":
      return "color-a-plus-plus-plus";
    case "a++":
      return "color-a-plus-plus";
    case "a+":
      return "color-a-plus";
    case "a":
      return "color-a";
    case "b":
      return "color-b";
    case "c":
      return "color-c";
    case "d":
      return "color-d";
    case "e":
      return "color-e";
    case "f":
      return "color-f";
    case "g":
      return "color-g";
    default:
      return "color-unknown";
  }
});
</script>
<template>
  <div class="energy-label-wrap">
    <span class="icon-energy-label" :class="colorClass"></span>
    <span class="energy-label-text">{{ formattedLabel }}</span>
  </div>
</template>
